<template>
  <div class="msgtypeVoice">
    <div class="msgtypeVoice_b">
      <div class="msgtypeVoice_icon1">
        <div class="msgtypeVoice_icon2"></div>
        <div class="msgtypeVoice_icon3"></div>
      </div>
      <p>{{ items.content.voice_size | ellipsis }}"</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  filters: {
    ellipsis(value) {
      if (!value) return '';
      const time = parseInt(value / 1000, 0);
      return time;
    },
  },
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeVoice {
  padding: 0 12px;
  box-sizing: border-box;
  display: inline-block;
  .msgtypeVoice_b {
    display: inline-block;
    background: #2f96ff;
    border-radius: 4px;
    line-height: 30px;
    height: 30px;
    padding: 0 8px;
    display: flex;
    p {
      color: #fff;
      margin-left: 20px;
    }
    .msgtypeVoice_icon1 {
      width: 16px;
      height: 16px;
      border-radius: 0 20px 0 0;
      border: 1px solid #2f96ff;
      border-top: 1px solid #ffffff;
      border-right: 1px solid #ffffff;
      position: relative;
      transform: rotate(45deg);
      top: 7px;
      .msgtypeVoice_icon2 {
        width: 8px;
        height: 8px;
        border-radius: 0 12px 0 0;
        border: 1px solid #2f96ff;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        position: absolute;
        top: 6px;
        left: 0;
      }
      .msgtypeVoice_icon3 {
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background: #ffffff;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}
</style>
